import loading from '../assets/images/loading.svg';


function Loader() {
  return (
      
      <div className="loaderDiv">
        <img src={loading} className="loaderImg" />
      </div>

  );
}

export default Loader;